import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { shouldShowFolderPane } from './shouldShowFolderPane';
import { shouldShowFolderPaneAsOverlay } from './shouldShowFolderPaneAsOverlay';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import {
    getIsBitSet,
    type ListViewBitFlagsMasks,
} from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';

export function shouldShowFavoritesSideRail(): boolean {
    return (
        isGlobalFeatureEnabled('fp-vertical-favorites') &&
        !getIsBitSet(16384, getGlobalSettingsAccountMailboxInfo()) &&
        (!shouldShowFolderPane() || shouldShowFolderPaneAsOverlay())
    );
}
